import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import useUpcomingEvents from '../../hooks/useUpcomingEvents';
import ArticleListing from '../ArticleListing/ArticleListing';
import ArticleSection from '../ArticleSection/ArticleSection';
import EventCard from '../EventCard/EventCard';
import AjaxSpinner from '../UI/AjaxSpinner/AjaxSpinner';
import Button, { themes as btnThemes } from '../UI/Button/Button';
import { GridReveal, GridItem } from '../UI/Grid/Grid';
import Section from '../UI/Section/Section';
import Type from '../UI/Type/Type';

const RECENT_POSTS_QUERY = graphql`
  query RecentPostsQuery {
    ...RecentPosts
  }
`;

const RecentPosts = ({ heading, ...other }) => {
  const { recentPosts } = useStaticQuery(RECENT_POSTS_QUERY);
  const upcomingEvents = useUpcomingEvents({ limit: 3 });

  return upcomingEvents.isLoading ? (
    <Section>
      <AjaxSpinner isCenter/>
    </Section>
  ) : !!upcomingEvents.nodes.length ? (
    <Section {...other}>
      <GridReveal>
        <GridItem md="6">
          <Type.MetaHeading as="h2">Recent articles</Type.MetaHeading>
          <ArticleListing nodes={recentPosts.nodes} isList />
          <Button theme={btnThemes.LINK_SIMPLE} to="/blog/">
            View more articles
          </Button>
        </GridItem>
        <GridItem md="6">
          <Type.MetaHeading as="h2">Upcoming events</Type.MetaHeading>
          <ArticleListing nodes={upcomingEvents.nodes} card={EventCard} isList />
          <Button theme={btnThemes.LINK_SIMPLE} to="/events/">
            View more events
          </Button>
        </GridItem>
      </GridReveal>
    </Section>
  ) : (
    <ArticleSection nodes={recentPosts.nodes} />
  );
};

export default RecentPosts;
